<template>
    <v-system-bar
        v-if="notificationMessage"
        dark
        height="auto"
        color="#e63f57"
        absolute
        class="notification-bar"
        :style="{ top: topPosition }"
    >
        <v-img class="notification-bar__icon" src="@/assets/warning.svg" />
        <div v-html="notificationMessage" class="notification-bar__info" />
    </v-system-bar>
</template>

<script>
export default {
    name: 'NotificationBar',
    props: {
        topPosition: {
            type: String,
            default: '0px',
        },
    },
    computed: {
        notificationMessage() {
            return this.$store.state.notification.message;
        },
    },
    created() {
        this.$store.dispatch('fetchNotification');
    },
};
</script>

<style lang="scss" scoped>
.notification-bar {
    $text-link-color: #fff;
    padding: 12px 30px;
    justify-content: center;

    &.theme--dark {
        color: $text-link-color;
    }

    &__icon {
        margin-right: 10px;
        width: 17px;
        max-width: 17px;
        height: 15px;
    }
    &__info ::v-deep {
        a {
            color: $text-link-color;
        }
        p {
            margin-bottom: 0;
        }
    }
}
</style>
